@let current = currentField();
@let isBlocked = blocked();
@let isDefault = type() === cardTypes.DEFAULT;

<card-base
    [field]="field()"
    [favoriteField]="favoriteField()"
    [trashField]="trashField()"
    [type]="type()"
    [disabled]="isBlocked"
    [selected]="selected()"
    [showAi]="false"
    [block]="true">

    <!-- Zona 1 do rail: os dados e a aparência abrem o assistente na etapa certa. -->
    <div card-toolbar class="chart-rail">
        @if (isDefault) {
            <button
                type="button"
                class="rail-chip"
                [class.default-disabled]="isBlocked"
                [disabled]="isBlocked"
                [attr.aria-label]="'document.edit.chart.card.editData' | translate"
                [raEditTooltip]="{ text: ('document.edit.chart.card.editData' | translate), position: 'left' }"
                (click)="open('data')">
                <ra-icon icon="table" varColor="currentColor" [size]="22" />
            </button>
            <button
                type="button"
                class="rail-chip"
                [class.default-disabled]="isBlocked"
                [disabled]="isBlocked"
                [attr.aria-label]="'document.edit.chart.card.look' | translate"
                [raEditTooltip]="{ text: ('document.edit.chart.card.look' | translate), position: 'left' }"
                (click)="open('look')">
                <ra-icon icon="palette" varColor="currentColor" [size]="22" />
            </button>
        }
    </div>

    @if (isDefault) {
        <!-- O desenho inteiro é o botão de editar os dados: é o que o usuário tenta primeiro. -->
        <button
            type="button"
            class="chart-open"
            [disabled]="isBlocked"
            [attr.aria-label]="('document.edit.chart.card.editData' | translate) + ' · ' + (kindLabelKey() | translate)"
            (click)="open('data')">
            <chart-view [value]="current?.value" />
            <span class="chart-hint" aria-hidden="true">
                <ra-icon icon="table" varColor="currentColor" [size]="14" />
                {{ 'document.edit.chart.card.editData' | translate }}
            </span>
        </button>
    } @else {
        <chart-view [value]="current?.value" />
    }
</card-base>
